import axios from '../../../libs/axios';

export interface Request {
  user_name: string;
  password: string;
  captcha_key: string;
  captcha: string;
  code: string;
}

export interface Response {
  status: number;
  msg: string;
  data: {
    token: string;
  };
}

export const login = (data: Request): Promise<Response> => {
  return axios.post('/3585eb89-060b-4f0d-8d43-eab6975d695e/login', data);
};
